module.exports = __webpack_public_path__ + "img/ZL.506d7a0d.png";